import { State } from '@viome/viome-base/src/usecase/Home/Home.model';
import { TimelineProgressBar } from './TrackingProgressBar';

interface TrackingSampleTimelineProps {
  steps: State[];
  currentStepId: number;
  hasIssue: boolean;
  errorText?: string;
}

export const Timeline = ({
  steps,
  currentStepId,
  hasIssue,
  errorText = '',
}: TrackingSampleTimelineProps) => {
  return (
    <div className="relative space-y-0">
      {steps
        .filter((step) => !hasIssue || step.id <= currentStepId)
        .map((step, index, filteredSteps) => (
          <TimelineProgressBar
            key={step.id}
            id={step.id}
            text={step.text}
            currentStepId={currentStepId}
            hasIssue={hasIssue}
            isLastStep={index === filteredSteps.length - 1}
            errorText={errorText}
          />
        ))}
    </div>
  );
};
